import React from 'react'
import { observer } from 'mobx-react'
import usePortManager from '../hooks/use-port-manager'
import useSettingsManager from '../hooks/use-settings-manager'
import usePriceManager from '../hooks/use-price-manager'

function PortPrice ({vat = false, total = false}) {

  const settings_manager = useSettingsManager()
  const label = vat === false ? settings_manager.getOtherSettings('port_price_label', 'Pris eksl. moms') : settings_manager.getOtherSettings('port_price_vat_label', 'Pris inkl. moms')

  const port_manager = usePortManager()

  const price_manager = usePriceManager()
  const price = function () {
    return total ? total_port_price() : current_port_price()
  }
  const total_port_price = function () {
    let key = vat === false ? 'price' : 'price_vat'
    return price_manager.getTotalPrice()[key]
  }
  const current_port_price = function () {
    let key = vat === false ? 'price' : 'price_vat'
    return price_manager.getPortPrice(port_manager.currentPort.port_id)[key]
  }

  return (
    <aside className={vat ? 'current-port-price vat' : 'current-port-price'}
           data-updating={price_manager.is_updating}>
      <p className={'price heading heading--5'} dangerouslySetInnerHTML={{ __html: price() }}/>
      <p className={'label'}>{label}</p>
    </aside>
  )
}

export default observer(PortPrice)